// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__29mac","addWidgetButton":"Header_addWidgetButton__3Z0Yh","dashboardTabs":"Header_dashboardTabs__32RX-","active":"Header_active__7XMaT"};